import { render, staticRenderFns } from "./CallActive.vue?vue&type=template&id=be16bd8e&"
import script from "./CallActive.vue?vue&type=script&lang=js&"
export * from "./CallActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports